
/*
    Defines the API route we are using.
*/

export const APP_CONFIG = {
    URL: `${process.env.VUE_APP_API_URL}/v1/`,
};
